import { lazy } from 'react'

export const homeLoadables = {
	LoadableHome: lazy(() => import('../containers/Home'))
}
